import React from 'react'
import { Divider, Container, Button, Grid, Header, List, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CustomMessage, Navbar } from 'components'
import 'styling/semantic.less'

class About extends React.Component {
    
  render() {
    return (
        <Segment padded='very'>
          <Header as='h1'>Petr Jašíček</Header>
          {/*<p><i>It takes the same time to do something the right way as the wrong way.</i> You just spend the time in different places.</p>*/}
          <p align="justify" style={{fontSize: 16}}>
            I am a chill guy who likes challenges. 
            My big hobby is reimplementing old classic games entirely from scratch and making the projects open source. 
          </p>
          <p align="justify" style={{fontSize: 16}}>
          When I am not currently working I am most likely spending time with my daughter, educating myself or lifting weights.
          </p>

          <Divider section />

          <Header as='h2'><mark>Ski</mark>lls & Expertise</Header>
          <p style={{fontSize: 16}}>
          Whenever I am posed with a task, I try to choose the most suitable tools and technologies for the job within my disposal.
          </p>

          <p style={{fontSize: 16}}><b>General skills: </b> OOP, Linux/UNIX, Networking, Cloud-native developent, SW architecture design, PKI, Security, Cryptography</p>
          <p style={{fontSize: 16}}><b>Programming languages: </b> C, C++11/14/17, Bash, JavaScript, C#, Java, Go</p>
          <p style={{fontSize: 16}}><b>Tools: </b> Docker, Docker-compose, Podman, Kubernetes, Makefile, CMake, Yocto</p>
          <p style={{fontSize: 16}}><b>Versioning systems: </b> Git, Perforce, ClearCase</p>
          <p style={{fontSize: 16}}><b>Languages: </b> English, Czech</p>

          <Divider section />

          <Header as='h2'><mark>Exp</mark>erience</Header>

          <Header as='h3'>Contractor</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li><b>Time frame: </b> Oct 2021 - Present</li>
              <li><b>Customers: </b> ExpertaLabs s.r.o, FibiWorks s.r.o</li>
              <li>Software development, Software architecture design</li>
            </ul>
          </p>

          <Header as='h3'>Siemens, s.r.o, Czech Republic, Brno</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li><b>Time frame: </b> Aug 2015 - Sep 2021</li>
              <li><b>Position: </b> Software engineer</li>
              <li><b>Main projects: </b></li>
              <ul style={{lineHeight: 2}}>
                <li>Road Side Units - Car2X system, C++, Java, Yocto Linux, Networking</li>
                <li>Traffic controllers - C, C++, Linux, Kernel drivers, Realtime, Complex system, Safety, Network connected</li>
              </ul>
            </ul>
          </p>
          <Header as='h3'>Red Hat Czech, s.r.o, Czech Republic, Brno</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li><b>Time frame: </b> Jul 2015 - Dec 2015</li>
              <li><b>Position: </b> Software engineer intern</li>
              <li><b>Main projects: </b></li>
              <ul style={{lineHeight: 2}}>
                <li>Mozilla Firefox - C, C++, Linux, GTK3, rpm packaging, upstream community</li>
              </ul>
            </ul>
          </p>

          <Divider section />

          <Header as='h2'><mark>Edu</mark>cation</Header>

          <Header as='h3'>Faculty of Electrical Engineering, Brno University of Technology</Header>
          <p style={{fontSize: 13}}><i>MASTER’S DEGREE IN COMPUTER SCIENCE AND TELECOMMUNICATIONS</i></p>
          <p style={{fontSize: 13}}><i>Sep 2017 - Jun 2019</i></p>

          <Header as='h3'>Faculty of Information Technology, Brno University of Technology</Header>
          <p style={{fontSize: 13}}><i>BACHELOR’S DEGREE IN COMPUTER SCIENCE</i></p>
          <p style={{fontSize: 13}}><i>Sep 2012 - Jun 2016</i></p>

          <Header as='h3'>Secondary Technical and Higher Technical School, Sokolská 1, Brno</Header>
          <p style={{fontSize: 13}}><i>HIGH SCHOOL</i></p>
          <p style={{fontSize: 13}}><i>Sep 2008 - Jun 2012</i></p>
        </Segment>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/About.js